import React from 'react';
import {t} from 'ttag';

export default class TimeoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };

    let body = document.body;
    body.classList.add("dark-theme");
  }

  render() {
    return (
      <div className="landing__section">
        <div className="row" style={{ padding: 20 }}>
          <div className="wrapper col-md-8" style={{ padding: 20 }}>
            <p style={{ fontSize: '1.75rem', textAlign: 'center' }}>{t`A rendelkezésre álló idő lejárt, a jegyek fel lettek szabadítva!`}</p>
            <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>{t`Annak érdekében, hogy a jegyek a lehető legtöbb ember számára hozzáférhetők legyenek, minden rendelés jobb felső sarkában egy időzítőt helyezünk el a fizetési folyamat során. Ha nem fejezi be a rendelést a  megadott határidőn belül, a jegyek mások számára felszabadításra kerülnek.`}</p>
            <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>{t`Kérjük kezdd elölről a rendelésed!`}</p>
            <button
              type="button"
              className="search-button-style btn btn-secondary float-right"
              onClick={() => {
                let redirectUrl = localStorage.getItem("redirecturl");
                window.location.replace(process.env.PUBLIC_URL + '/event/' + redirectUrl);
              }}
            >{t`Vissza`}</button>
          </div>
        </div>
      </div>
    );
  }
}